import { addMessages } from '@hana/i18n';

// Khoá chuỗi của bảng phải Báo giá (QuoteDock.tsx). Trạng thái báo giá, mã, khách là dữ liệu — không dịch.
addMessages('vi', {
  'qd.tab.an': 'Phân tích', 'qd.tab.task': 'Việc', 'qd.tab.noti': 'Thông báo',
  'qd.tabs': 'Bảng bên phải', 'qd.close': 'Đóng bảng', 'qd.month': 'Tháng 10/2026',
  'qd.gaugeAria': 'Tỉ lệ chốt {r}%: {a} trên {s} báo giá đã gửi', 'qd.rate': 'Tỉ lệ chốt', 'qd.sentQ': '{a} / {s} BG đã gửi',
  'qd.acc': 'Khách chấp nhận + đã thành Job', 'qd.sent': 'Đã gửi', 'qd.exp': 'Sắp hết hạn', 'qd.qt': 'BG',
  'qd.mix': 'Cơ cấu trạng thái', 'qd.mixAria': 'Báo giá theo trạng thái: {v}', 'qd.expH': 'Sắp hết hạn · 7 ngày',
  'qd.today': 'hôm nay', 'qd.left': 'còn {n} ngày', 'qd.done': 'Xong: {k}',
});
addMessages('en', {
  'qd.tab.an': 'Analytics', 'qd.tab.task': 'Tasks', 'qd.tab.noti': 'Notifications',
  'qd.tabs': 'Right panel', 'qd.close': 'Close panel', 'qd.month': 'October 2026',
  'qd.gaugeAria': 'Win rate {r}%: {a} of {s} quotes sent', 'qd.rate': 'Win rate', 'qd.sentQ': '{a} / {s} quotes sent',
  'qd.acc': 'Customer accepted + converted to Job', 'qd.sent': 'Sent', 'qd.exp': 'Expiring soon', 'qd.qt': 'quotes',
  'qd.mix': 'Status mix', 'qd.mixAria': 'Quotes by status: {v}', 'qd.expH': 'Expiring · 7 days',
  'qd.today': 'today', 'qd.left': '{n} days left', 'qd.done': 'Done: {k}',
});
